module.exports = __webpack_public_path__ + "static/media/img_mobile_premiem_bg.bc4d60db.png";